import UtilService from "../../service/UtilService";
import { useImmer } from "use-immer";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons/faTrashCan";

const Component = ({ config, onChange }) => {
  const scoreConfigTemplate = { countryCodes: [""], scoreOnMatch: 0.0 };
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    onChange(data);
  }, [data]);

  useEffect(() => {
    updateData(config);
  }, [config]);

  const addScore = () => {
    updateData((d) => {
      d.scores.push(structuredClone(scoreConfigTemplate));
    });
  };

  const removeScore = (index) => {
    updateData((d) => {
      d.scores.splice(index, 1);
    });
  };

  return (
    <>
      <table className="config-table table-with-button">
        <thead>
          <tr>
            <th>Country codes</th>
            <th>Score</th>
            <th>
              <FontAwesomeIcon
                icon={faPlus}
                className="icon-clickable"
                onClick={() => addScore()}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.scores.map((score, index) => (
            <tr key={index}>
              <td>
                <input
                  type="text"
                  value={UtilService.arrayToCsv(score.countryCodes)}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].countryCodes =
                        UtilService.csvToStringArray(e.target.value);
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  value={score.scoreOnMatch}
                  min="0"
                  step="0.1"
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].scoreOnMatch = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="icon-clickable"
                  onClick={() => removeScore(index)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Component;
